<app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>

<div
	class="row"
	*ngIf="loading">
	<div class="col text-center">
		<app-loader [material]="false"></app-loader>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && activity">
	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="tab-card">

			<nav
				ngbNav
				[navsetlink]="nav"
				#nav="ngbNav"
				class="nav-tabs">
				<ng-container ngbNavItem="dati">
					<a
						routerLink="."
						fragment="dati"
						ngbNavLink>
						Dati
					</a>
					<ng-template ngbNavContent>
						<p [innerHTML]="activity.description"></p>
						<table
							class="table"
							*ngIf="activity">
							<tbody>
								<tr *ngIf="activity.id">
									<td>{{ 'labels.id' | translate }}</td>
									<td>{{ activity.id }}</td>
								</tr>
								<tr *ngIf="activity.name">
									<td>{{ 'labels.name' | translate }}</td>
									<td>{{ activity.name }}</td>
								</tr>
								<tr *ngIf="objective.name">
									<td>{{'labels.objective' | translate }}</td>
									<td>{{ objective.name }}</td>
								</tr>
								<tr *ngIf="project.name">
									<td>{{'labels.project' | translate }}</td>
									<td>{{ project.name }}</td>
								</tr>
								<tr>
									<td>{{'labels.startdate' | translate }}</td>
									<td>
										{{ activity.startdate | date:'dd/MM/yyyy'}}
									</td>
								</tr>
								<tr>
									<td>{{'labels.stopdate' | translate }}</td>
									<td>
										{{ activity.stopdate | date:'dd/MM/yyyy'}}
									</td>
								</tr>

								<tr>
									<td>{{'labels.insdate' | translate }}</td>
									<td>
										{{ activity.insdate | date:'dd/MM/yyyy - hh:mm:ss'}}
									</td>
								</tr>
								<tr>
									<td>{{'labels.moddate' | translate }}</td>
									<td>
										{{ activity.moddate | date:'dd/MM/yyyy - hh:mm:ss'}}
									</td>
								</tr>

								<tr>
									<td>{{'labels.type' | translate }}</td>
									<td>
										{{ 'labels.'+activity.taxonomy | translate }}
									</td>
								</tr>

								<div class="row mt-1">
									<div class="col">
										<button
											routerLink="/project/objective/{{objective.id}}/activity/edit/{{activity.id}}"
											class="btn btn-primary"
											*ngIf="project?.isDraft && !usercompanyid">
											{{'labels.edit' | translate | titlecase}}
										</button>
									</div>
								</div>
							</tbody>
						</table>

					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="milestone">
					<a
						routerLink="."
						fragment="milestone"
						ngbNavLink>
						Milestone
					</a>
					<ng-template ngbNavContent>
						<app-milestone-list
							[activityid]="activity.id"
							[projectid]="project.id"
							[usercompanyid]="usercompanyid"></app-milestone-list>

					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="deliverable">
					<a
						routerLink="."
						fragment="deliverable"
						ngbNavLink>
						Deliverable
					</a>
					<ng-template ngbNavContent>
						<app-deliverable-list
							[activityid]="activity.id"
							[projectid]="project.id"
							[usercompanyid]="usercompanyid"></app-deliverable-list>

					</ng-template>
				</ng-container>

				<ng-container
					ngbNavItem="sezioniaggiuntive"
					[disabled]="!activity.id">
					<a
						routerLink="."
						fragment="sezioniaggiuntive"
						ngbNavLink>
						Sezioni aggiuntive
					</a>
					<ng-template ngbNavContent>
						<app-additional-sections
							*ngIf="project"
							[eid]="activity.id"
							[tenderid]="project.tenderid"
							entity="activity"></app-additional-sections>
					</ng-template>
				</ng-container>

				<ng-container ngbNavItem="documenti">
					<a
						routerLink="."
						fragment="documenti"
						ngbNavLink>
						Documenti
					</a>
					<ng-template ngbNavContent>
						<app-attachments
							[extradata]="{'company' : project?.company?.id}"
							[card]="false"
							mediapath="download"
							[library]="true"
							entity="activity"
							[bootstrap]="true"
							[canvalidate]="true"
							[eid]="activity.id">
						</app-attachments>

					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="indicatori">
					<a
						routerLink="."
						fragment="indicatori"
						ngbNavLink>
						Indicatori
					</a>
					<ng-template ngbNavContent>
						<app-activitykpi-list
							[activityid]="activity.id"
							[projectid]="project.id"></app-activitykpi-list>
					</ng-template>
				</ng-container>
			</nav>

			<div
				[ngbNavOutlet]="nav"
				class="mt-2"></div>

		</app-card>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading && error">
	<div class="col-sm-12">
		<app-card [hidHeader]="true">
			{{'errors.loading.activity' | translate}}
		</app-card>

	</div>
</div>
